import React from 'react';

class Skill extends React.Component {
  render() {
    return (
      <div className="section-skills-skill">
        <a href={this.props.link} target="_blank">
          <img src={this.props.icon} width="100%" height="100%" alt={this.props.name} title={this.props.name}/>
        </a>
      </div>
    );
  }
}

export default Skill;
